'use client'

import { Cancel, InsertDriveFileOutlined } from '@mui/icons-material'
import { Chip, CircularProgress } from '@mui/material'

type AttachmentChipProps = {
  filename: string
  uploading?: boolean
  failed?: boolean
  /** Shown as the chip's tooltip, e.g. why the upload failed. */
  title?: string
  onDelete?: () => void
  deleteLabel?: string
}

/** One attached file, in the composer while it uploads and on the message that carried it. */
export default function AttachmentChip({
  filename,
  uploading = false,
  failed = false,
  title,
  onDelete,
  deleteLabel
}: AttachmentChipProps) {
  return (
    <Chip
      size="small"
      variant="outlined"
      color={failed ? 'error' : 'default'}
      icon={uploading ? <CircularProgress size={14} /> : <InsertDriveFileOutlined fontSize="small" />}
      label={filename}
      title={title ?? filename}
      onDelete={onDelete}
      deleteIcon={onDelete ? <Cancel aria-label={deleteLabel} /> : undefined}
      sx={{ maxWidth: '100%' }}
    />
  )
}
